/**
 * WeekChips.tsx
 * Per-week breakdown chip strip for the Add Assignment dialog.
 * Extracted from AddAssignmentDialog.tsx to stay under 600-line cap.
 * Follow-up 1.6 / Phase 3 Item 5.
 */

import React from 'react';
import { Chip } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { useTheme } from '@mui/material/styles';
import { weekOfMondayLabel } from '../../../components/schedule/employeeScheduleShared';

export interface WeekSplit {
  weekStart: string;
  workingDays: number;
  percent: number;
  holidays: string[];
}

interface WeekChipsProps {
  splits: WeekSplit[];
}

export const WeekChips: React.FC<WeekChipsProps> = ({ splits }) => {
  const theme = useTheme();
  return (
    <>
      {splits.map((split) => {
        const hasHoliday = split.holidays.length > 0;
        return (
          <Chip
            key={split.weekStart}
            icon={<CalendarTodayIcon sx={{ fontSize: '0.65rem !important' }} />}
            label={`Week of ${weekOfMondayLabel(split.weekStart)}: ${split.workingDays} day${split.workingDays !== 1 ? 's' : ''} off${hasHoliday ? ' — stat holiday' : ''}`}
            size="small"
            sx={{
              height: 22,
              fontSize: '0.65rem',
              backgroundColor: hasHoliday
                ? `${theme.schedule.conflictSoft}22`
                : theme.table.headerBg,
              color: theme.palette.text.secondary,
              border: `1px solid ${theme.border.color}`,
              '& .MuiChip-label': { px: 0.75 },
            }}
          />
        );
      })}
    </>
  );
};

/**
 * Build the splits array when vacationSplits is empty
 * (fallback for non-vacation types or when data is not yet loaded).
 */
export function buildFallbackSplits(weekStarts: string[]): WeekSplit[] {
  return weekStarts.map((ws) => ({
    weekStart: ws,
    workingDays: 5,
    percent: 100,
    holidays: [],
  }));
}
